module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    staticClass: "spinner spinner--cube",
    style: (_vm.styles),
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 500.00001 500.00001"
    }
  }, [_c('g', {
    attrs: {
      "fill": _vm.color
    }
  }, [_c('path', {
    staticClass: "b0",
    attrs: {
      "d": "M66.734 66.734v366.533h366.532V66.734H66.734zm15 15h336.532v336.533H81.734V81.734z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "b2",
    attrs: {
      "d": "M354.16 2.5v143.34H497.5V2.5H354.16zm10 10H487.5v123.34H364.16V12.5z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "b1",
    attrs: {
      "d": "M0 2.5v143.34h143.34V2.5H0zm10 10h123.34v123.34H10V12.5z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "b3",
    attrs: {
      "d": "M354.16 356.66V500H497.5V356.66H354.16zm10 10H487.5V490H364.16V366.66z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "b4",
    attrs: {
      "d": "M0 356.66V500h143.34V356.66H0zm10 10h123.34V490H10V366.66z"
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bdbf7868"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-loading-spinner/src/components/RotateSquare3.vue
// module id = 955
// module chunks = 170